const initialState = {
	findSystemGroups: null,
};

const systemGroupReducer = (state = initialState, action ) => {
	switch (action.type) {
		case "FIND_SYSTEM_GROUPS":
			state = {
				...state,
				findSystemGroups: action.payload
			};
			break;
		case "UPDATE_SYSTEM_GROUP_CONTACT_COUNT": {
			const { groupId, ownerId, nbOfContact } = action.payload || {};
			if (state.findSystemGroups && Array.isArray(state.findSystemGroups.systemGroups)) {
				let changed = false;
				const nextSystemGroups = state.findSystemGroups.systemGroups.map(item => {
					if (String(item.id) === String(groupId) && (!ownerId || String(item.ownerId) === String(ownerId)) && Number(item.nbOfContact) !== Number(nbOfContact)) {
						changed = true;
						return { ...item, nbOfContact };
					}
					return item;
				});
				if (changed) {
					state = {
						...state,
						findSystemGroups: {
							...state.findSystemGroups,
							systemGroups: nextSystemGroups
						}
					};
				}
			}
			break;
		}
		default :
			break;
	}
	return state;
};

export default systemGroupReducer;